import * as types from '../mutation-types'
import mailRepository from '../../api/mailRepository'

const state = {
    mailToSend: {},
    isMailSent: false,
    isOrderMailSent: false,
    isQuoteMailSent: false
}

const getters = {
    mailToSend: state => state.mailToSend,
    isMailSent: state => state.isMailSent,
    isOrderMailSent: state => state.isOrderMailSent,
    isQuoteMailSent: state => state.isQuoteMailSent
}

const actions = {
    sendContactMail({ commit }) {
        return mailRepository.sendContactMail(state.mailToSend).then((response) => {
            if (response.data.success) {
                commit(types.SET_MAIL_IS_SENT, true)
            } else {
                commit(types.SET_MAIL_IS_SENT, false)
            }
        })
    },
    sendBecomeCustomerMail({ commit }) {
        return mailRepository.sendBecomeCustomerMail(state.mailToSend).then((response) => {
            if (response.data.success) {
                commit(types.SET_MAIL_IS_SENT, true)
            } else {
                commit(types.SET_MAIL_IS_SENT, false)
            }
        })
    },
    sendOrderConfirmationMail({ commit }, orderId) {
        return mailRepository.sendOrderConfirmationMail(orderId).then((response) => {
            if (response.data.success) {
                commit(types.SET_ORDER_MAIL_IS_SENT, true)
            } else {
                commit(types.SET_ORDER_MAIL_IS_SENT, false)
            }
        })
    },
    sendQuoteConfirmationMail({ commit }, order, products, admin) {
        return mailRepository.sendQuoteConfirmationMail(order, products, admin).then((response) => {
            if (response.data.success) {
                commit(types.SET_QUOTE_MAIL_IS_SENT, true)
            } else {
                commit(types.SET_QUOTE_MAIL_IS_SENT, false)
            }
        })
    }
}

const mutations = {
    [types.SET_MAIL_TO_SEND](state, payload) {
        state.mailToSend = payload
    },
    [types.SET_MAIL_IS_SENT](state, payload) {
        state.isMailSent = payload
    },
    [types.SET_ORDER_MAIL_IS_SENT](state, payload) {
        state.isOrderMailSent = payload
    },
    [types.SET_QUOTE_MAIL_IS_SENT](state, payload) {
        state.isQuoteMailSent = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
